import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Observable } from 'rxjs';
import { NonEduOrgDataResponse, NonEduOrgFieldJson, NonEduOrgPostPayload, NonEduOrgPutPayload } from '../models/non-edu-org-data.model';

@Injectable({
  providedIn: 'root'
})
export class NonEduOrgService {
  httpClient = inject(HttpClient);

  fetchNonEduOrgDetails(pageNumber: number, pageSize: any, sortDetails?: any, filterDetails?: any) {
    let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize);
    if (sortDetails)
      Object.keys(sortDetails).forEach(key => {
        if (sortDetails[key])
          params = params.set(key, sortDetails[key]);
      });
    if (filterDetails?.size)
      filterDetails.forEach((value: any, key: any) => {
        params = params.set(key, value);
      });
    return this.httpClient.get(apiEndpointURL.nonEduOrgEndpoint, { params });
  }

  archiveUnarchiveNonEduOrg(organisationId: number, status: string, userId: number) {
    const url = [apiEndpointURL.nonEduOrgEndpoint, organisationId, status].join('/');
    const bodyContent = { updatedBy: userId };
    return this.httpClient.patch(url, bodyContent);
  }

  fetchReferenceData(type?: string, filterBy?: string) {
    let url = apiEndpointURL.nonEduOrgReferenceEndpoint;
    if (type === 'AJAX' && filterBy) {
      const params = new HttpParams().set("filterBy", filterBy);
      url = url.replace('/referenceData', '') + '/filterData';
      return this.httpClient.get(url, { params });
    }
    return this.httpClient.get(url);
  }

  getNonEduOrgJson(): Observable<NonEduOrgFieldJson> {
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.get<any>(apiEndpointURL.nonEduOrgFieldJson, { params });
  }

  createNonEduOrg(detailsToSave: NonEduOrgPostPayload) {
    return this.httpClient.post(apiEndpointURL.nonEduOrgEndpoint, detailsToSave);
  }

  updateNonEduOrg(detailsToSave: NonEduOrgPutPayload, nonEduOrgId: string) {
    return this.httpClient.put([apiEndpointURL.nonEduOrgEndpoint, nonEduOrgId].join('/'), detailsToSave);
  }

  getNonEduOrgDetailById(nonEduOrgId: string, from?: string): Observable<NonEduOrgDataResponse> {
    let params = new HttpParams();
    if (from === 'resolver') params = params.set('resolver', 'true');
    return this.httpClient.get<NonEduOrgDataResponse>([apiEndpointURL.nonEduOrgEndpoint, nonEduOrgId].join('/'), { params });
  }
}
